import feathersClient, {
  makeServicePlugin,
  BaseModel
} from '../../feathers-client'

class FlagState extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'FlagState'
  // Define default properties here
  static instanceDefaults() {
    return {
      name: '',
      enabled: false
    }
  }
  // static setupInstance(data) {
  //   if (data.createdAt) {
  //     data.createdAt = new Date(data.createdAt)
  //   }
  //   return data
  // }
}
const servicePath = 'flag-states'
const servicePlugin = makeServicePlugin({
  Model: FlagState,
  service: feathersClient.service(servicePath),
  servicePath,
  debug: true
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
